import { Segmented } from 'antd';
import { TransactionFilters } from 'widgets/transactions/model/types';
import { useIntl } from 'react-intl';
import React from 'react';
import { getFilterName } from '../model/utils';

type FiltersProps = {
  filters: TransactionFilters[];
  onSelect?: (filter: TransactionFilters | 'All' | null) => unknown;
};

const Filters: React.FC<FiltersProps> = ({ filters, onSelect }) => {
  const { formatMessage: t } = useIntl();

  const onClickFilter = (type: TransactionFilters) => {
    onSelect?.(type);
  };

  const options = [
        { value: 'All', label: t({ id: 'transactions.filter.all' }) },
        ...Object.values(filters).map((filter) => {
          if (filter !== TransactionFilters.QUERY)
            return {
              value: filter,
              label: (
                <div id={`transaction-label__${filter.toLowerCase()}`}>
                  {getFilterName({ t, filter })}
                </div>
              ),
            };
        }).filter(Boolean) as { value: TransactionFilters; label: React.ReactNode }[],
      ];

  return (
    <Segmented
      block
      style={{ marginBottom: 16, width: '100%' }}
      options={options}
      onChange={(value) => onClickFilter(value as TransactionFilters)}
    />
  );
};

export default Filters;
